const unbreakableSpace = '\xa0\xa0';

export const getOptionalLabelParent = (space) => (options) => `${options.cod}\xa0${
  space > options.cod.length
    ? unbreakableSpace.repeat(space - options.cod.length)
    : ''
}${options.description}`;

export const getBigger = (params) => {
  let maxCodLength = 0;

  // eslint-disable-next-line no-restricted-syntax
  for (const param of params) {
    maxCodLength = Math.max(maxCodLength, param.cod.length);
  }

  return maxCodLength;
};
